import {Component, HostListener, OnInit} from '@angular/core';
import {CotizacionAgrisViewModel, CotizacionesAgrisFilterViewModel} from '../../common/AgrisViewModels';
import {AgrisService} from '../../../../services';

@Component({
  selector: 'app-agregar-ins-a-cotiz-existente-dialog',
  templateUrl: './agregar-ins-a-cotiz-existente-dialog.component.html',
  styleUrls: ['./agregar-ins-a-cotiz-existente-dialog.component.scss', '../../common/agris-common-styles.scss']
})
export class AgregarInsACotizExistenteDialogComponent implements OnInit {

  searchTerm = '';
  cotizaciones: CotizacionAgrisViewModel[] = [];
  loading = false;

  selectedCotizacion = null;

  sucursal = 0;

  estadosValidos = [
    'PENDIENTE',
    'GUARDADA',
    'ENVIADA',
    'CONFIRMADA',
    'VENCIDA',
    'PERDIDA',
    'RENOVADA'
  ]

  selectedIndex = -1;

  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.onSearch();
  }

  constructor(
    private agrisService: AgrisService,
  ) { }

  ngOnInit() {
    this.onSearch();
  }

  onSearch() {
    this.selectedIndex = -1;
    this.loading = true;
    const payload: CotizacionesAgrisFilterViewModel = {
      MisCotizaciones: false,
      OrderByFechaCreacion: true,
      PageNumber: 0,
      PageSize: 100,
      filter: this.searchTerm,
      Pendientes: true,
      SucursalId: this.sucursal,
    }
    this.agrisService.searchCotizaciones(payload).subscribe(x => {
      this.cotizaciones = x;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.agrisService.showSnackbarAPIError();
    });
  }

  onSubmit() {

  }

  getEstadoClass(coti: CotizacionAgrisViewModel) {
    // VERIFICAMOS QUE EL VALOR ESTA EN LOS PARAMETROS VALIDOS
    const estado = coti.EstadosCotizacion[0].CotizacionAgrisEstado.split(' ')[0].toUpperCase();
    return estado === '' || this.estadosValidos.indexOf(estado) === -1 ? 'NO-VALIDO' : estado;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-detalle-insumo-page/agregar-ins-a-cotiz-existente-dialog/agregar-ins-a-cotiz-existente-dialog.component.ts